import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import { BulkAction, ModalService, DataService } from "@bb-vendure/admin-ui/core";
import { DeleteDefaultProductDescriptionTranslationDocument, DeleteDefaultProductDescriptionTranslationMutation } from "src/generated-gql/graphql";

const deleteBulkAction: BulkAction = {
  location: "default-product-description-translation-list",
  label: "Delete Selected Translations",
  icon: "trash",
  iconClass: "is-danger",
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    modalService
      .dialog({
        title: "Delete Selected Translations",
        body: `Are you sure you want to delete ${selection.length} translation${selection.length > 1 ? "s" : ""}?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteDefaultProductDescriptionTranslationMutation>[] = [];
          for (const i in result) {
            deleteObservables.push(
              dataService.mutate(DeleteDefaultProductDescriptionTranslationDocument, {
                id: result[i].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe(() => {
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};

export { deleteBulkAction };
